import React from 'react';
import PropTypes from 'prop-types';
import ShipIcon from './ShipIcon';
import { format } from 'date-fns';
import { parseUTC } from 'core/utils';
import {
	Wrapper, Text,
} from './styles';

export const formatDate = (d) => {
	const dt = parseUTC(d);
	return format(dt, 'MMMM do');
};

const LastDayToOrder = ({ orderBy, arriveBy, arriveByName }) => orderBy && (arriveBy || arriveByName) ? (
	<Wrapper>
		<ShipIcon width="2em" height="1.5em" />
		<Text>Order by { formatDate(orderBy) } and get it by { arriveByName || formatDate(arriveBy) }</Text>
	</Wrapper>
) : null;

LastDayToOrder.propTypes = {
	orderBy: PropTypes.string,
	arriveBy: PropTypes.string,
	arriveByName: PropTypes.string,
};

LastDayToOrder.defaultProps = {};

export default LastDayToOrder;
